import React, { useState } from 'react';
import { Home, User, GraduationCap, FileText, Calendar, ThumbsUp, DollarSign, Scale, Grid3x3, ChevronRight, Menu, School, ChevronLeft } from 'lucide-react';

const CJWrapperNav = () => {
  const [activeMainTab, setActiveMainTab] = useState('essays');
  const [activeSubTab, setActiveSubTab] = useState('ideation');
  const [hoveredIcon, setHoveredIcon] = useState(null);
  const [selectedVariation, setSelectedVariation] = useState(1);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const navItems = [
    { id: 'hub', label: 'Hub', icon: Grid3x3, color: 'teal' },
    { id: 'profile', label: 'Profile', icon: User, color: 'azure' },
    { id: 'colleges', label: 'Colleges', icon: GraduationCap, color: 'indigo' },
    { id: 'essays', label: 'Essays', icon: FileText, color: 'teal' },
    { id: 'timeline', label: 'Timeline', icon: Calendar, color: 'coral' },
    { id: 'recommendations', label: 'Recommendations', icon: ThumbsUp, color: 'gold' },
    { id: 'aid', label: 'Aid', icon: DollarSign, color: 'azure' },
    { id: 'compare', label: 'Compare', icon: Scale, color: 'indigo' },
  ];


  const profileSubTabs = [
    { id: 'academic', label: 'Academic Profile' },
    { id: 'assessment', label: 'Strategic Assessment' },
    { id: 'ai-insights', label: 'AI Insights' },
    { id: 'transcript', label: 'Transcript Request' },
    { id: 'export-manage', label: 'Export & Manage' }
  ];
  
  const essaySubTabs = [
    { id: 'freewriting', label: 'Free Writing' },
    { id: 'ideation', label: 'Ideation' },
    { id: 'topics', label: 'Topics' },
    { id: 'outlines', label: 'Outlines' },
    { id: 'drafts', label: 'Drafts' },
    { id: 'slots', label: 'Essay Slots' },
  ];

  const collegesSubTabs = [
    { id: 'all-schools', label: 'All Schools' },
    { id: 'my-schools', label: 'My Schools' },
    { id: 'comparisons', label: 'Comparisons' },
    { id: 'tier-analysis', label: 'Tier Analysis' },
    { id: 'portfolio-strategy', label: 'Portfolio Strategy' },
  ];

  const recommendationsSubTabs = [
    { id: 'all-recommendations', label: 'All Recommendations' },
    { id: 'brag-sheet', label: 'Brag Sheet' },
    { id: 'request-generator', label: 'Request Generator' },
    { id: 'recommender-packet', label: 'Recommender Packet' },
    { id: 'follow-ups', label: 'Follow Ups' },
    { id: 'thank-you', label: 'Thank You Letter' },
  ];

  const aidSubTabs = [
    { id: 'financial-aid', label: 'Financial Aid' },
    { id: 'scholarships', label: 'Scholarships' }
  ];
  const timelineSubTabs = [
    { id: 'timeline', label: 'Full Timeline' },
    { id: 'college-timelines', label: 'College Timelines' },
  ];


  const colorMap = {
    teal: { bg: 'bg-teal-500', text: 'text-teal-500', border: 'border-teal-500' },
    azure: { bg: 'bg-azure-500', text: 'text-azure-500', border: 'border-azure-500' },
    indigo: { bg: 'bg-indigo-500', text: 'text-indigo-500', border: 'border-indigo-500' },
    magenta: { bg: 'bg-magenta-500', text: 'text-magenta-500', border: 'border-magenta-500' },
    coral: { bg: 'bg-coral-500', text: 'text-coral-500', border: 'border-coral-500' },
    gold: { bg: 'bg-gold-500', text: 'text-gold-500', border: 'border-gold-500' },
  };

  const [currentCollege, setCurrentCollege] = useState(1);
  const [showQuickNav, setShowQuickNav] = useState(false);
  
  // Mock college data
  const colleges = {
    reach: [
      { id: 1, name: 'UChicago', location: 'Chicago, IL', category: 'Reach', round: 'Regular Decision', acceptance: '4.0%' },
      { id: 2, name: 'Duke University', location: 'Durham, NC', category: 'Reach', round: 'Early Decision (ED)', acceptance: '7.0%' },
      { id: 3, name: 'Massachusetts Institute of Technology', location: 'Cambridge, MA', category: 'Reach', round: 'Early Action (EA)', acceptance: '5.0%' },
      { id: 4, name: 'California Institute of Technology', location: 'Pasadena, CA', category: 'Reach', round: 'Regular Decision', acceptance: '3.0%' }
    ],
    target: [
      { id: 5, name: 'Virginia Tech', location: 'Blacksburg, VA', category: 'Target', round: 'Early Action (EA)', acceptance: '55.0%' },
      { id: 6, name: 'University of North Carolina at Chapel Hill', location: 'NC', category: 'Target', round: 'Regular Decision', acceptance: '19.0%' },
      { id: 7, name: 'Rice University', location: 'Houston, TX', category: 'Target', round: 'Early Action (EA)', acceptance: '8.0%' },
      { id: 8, name: 'Georgia Institute of Technology', location: 'Atlanta, GA', category: 'Target', round: 'Early Decision II', acceptance: '14.0%' }
    ],
    safety: [
      { id: 9, name: 'University of Florida', location: 'Gainesville, FL', category: 'Safety', round: 'Regular Decision', acceptance: '24.0%' },
      { id: 10, name: 'Purdue University', location: 'West Lafayette, IN', category: 'Safety', round: 'Regular Decision', acceptance: '50.0%' },
      { id: 11, name: 'North Carolina State University', location: 'Raleigh, NC', category: 'Safety', round: 'Early Action (EA)', acceptance: '42.0%' },
      { id: 12, name: 'University of Minnesota Twin Cities', location: 'Minneapolis, MN', category: 'Safety', round: 'Regular Decision', acceptance: '80.0%' }
    ]
  };

  const allColleges = [...colleges.reach, ...colleges.target, ...colleges.safety];
  const college = allColleges[currentCollege - 1];
  
  const getCategoryColor = (category) => {
    switch(category) {
      case 'Reach': return 'border-coral-500 bg-coral-50';
      case 'Target': return 'border-gold-500 bg-gold-50';
      case 'Safety': return 'border-teal-500 bg-teal-50';
      default: return 'border-slate-300 bg-stone-50';
    }
  };

  const getCategoryTextColor = (category) => {
    switch(category) {
      case 'Reach': return 'text-coral-700';
      case 'Target': return 'text-gold-700';
      case 'Safety': return 'text-teal-700';
      default: return 'text-slate-700';
    }
  };

  const handlePrevious = () => {
    if (currentCollege > 1) setCurrentCollege(currentCollege - 1);
  };

  const handleNext = () => {
    if (currentCollege < allColleges.length) setCurrentCollege(currentCollege + 1);
  };

  // Helper function to get current subtabs based on active main tab
  const getCurrentSubTabs = () => {
    switch (activeMainTab) {
      case 'profile':
        return profileSubTabs;
      case 'essays':
        return essaySubTabs;
      case 'colleges':
        return collegesSubTabs;
      case 'recommendations':
        return recommendationsSubTabs;
      case 'aid':
        return aidSubTabs;
      case 'timeline':
        return timelineSubTabs;
      default:
        return essaySubTabs; // Default fallback
    }
  };

  const WrapperDesign1 = ({ isMobile = false }) => {
    const activeItem = navItems.find(item => item.id === activeMainTab);
    const activeColor = colorMap[activeItem?.color];
    

    if (isMobile) {
      return (
        <div className="bg-stone-50 px-4 py-4">
          {/* Mobile Header with Active Indicator */}
          <div className="flex items-center justify-between mb-4">
            <div className="flex items-center gap-2">
              <div className={`w-1 h-10 rounded-full ${activeColor?.bg}`} />
              <div>
                <div className="text-xs text-slate-600">College Journey</div>
                <div className="text-sm font-bold text-slate-900">{activeItem?.label}</div>
              </div>
            </div>
            <button 
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className={`w-10 h-10 rounded-full border-2 border-slate-900 flex items-center justify-center transition-all ${
                mobileMenuOpen ? 'bg-slate-900' : 'bg-white'
              }`}
            >
              <Menu className={`w-5 h-5 ${mobileMenuOpen ? 'text-white' : 'text-slate-900'}`} />
            </button>
          </div>

          {/* Mobile Navigation Grid */}
          {mobileMenuOpen && (
            <div className="mb-4 border-2 border-slate-900 rounded-xl bg-white p-3">
              <div className="grid grid-cols-4 gap-2">
                {navItems.map((item) => {
                  const Icon = item.icon;
                  const isActive = activeMainTab === item.id;
                  const itemColor = colorMap[item.color];
                  
                  return (
                    <button
                      key={item.id}
                      onClick={() => {
                        setActiveMainTab(item.id);
                        setMobileMenuOpen(false);
                      }}
                      className="relative flex flex-col items-center gap-2 p-3 rounded-xl transition-all"
                    >
                      <div className={`w-12 h-12 rounded-full flex items-center justify-center transition-all ${
                        isActive 
                          ? `${itemColor.bg} border-2 border-slate-900` 
                          : 'bg-stone-100'
                      }`}>
                        <Icon className={`w-5 h-5 ${isActive ? 'text-white' : 'text-slate-600'}`} />
                      </div>
                      <span className={`text-xs text-center ${isActive ? 'text-slate-900 font-medium' : 'text-slate-600'}`}>
                        {item.label}
                      </span>
                      {isActive && (
                        <div className={`absolute top-0 right-0 w-2 h-2 rounded-full ${itemColor.bg}`} />
                      )}
                    </button>
                  );
                })}
              </div>
            </div>
          )}

          {/* Mobile Sub-navigation - Improved */}
          <div className="border-2 border-slate-900 rounded-xl bg-white p-2">
            <div className="overflow-x-auto -mx-2 px-2">
              <div className="flex items-center gap-1.5 min-w-max">
                {getCurrentSubTabs().map((tab) => {
                  const isActive = activeSubTab === tab.id;
                  return (
                    <button
                      key={tab.id}
                      onClick={() => setActiveSubTab(tab.id)}
                      className={`px-4 py-2.5 rounded-lg text-sm whitespace-nowrap transition-all ${
                        isActive 
                          ? 'bg-slate-900 text-white font-medium' 
                          : 'text-slate-700 hover:bg-stone-100'
                      }`}
                    >
                      {tab.label}
                    </button>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className="bg-stone-50 px-8 py-6">
        {/* Top Bar */}
        <div className="flex items-center justify-between mb-6">
          {/* Left: Enhanced Breadcrumb with Color Accent */}
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full bg-white border-2 border-slate-900 flex items-center justify-center">
              <Home className="w-5 h-5 text-slate-900" />
            </div>
            <ChevronRight className="w-4 h-4 text-stone-400" />
            <span className="text-sm text-slate-600">College Journey</span>
            <ChevronRight className="w-4 h-4 text-stone-400" />
            <div className={`px-2 py-2 flex items-center gap-2 `}>
              <span className="text-sm text-slate-900 font-medium">{activeItem?.label}</span>
              <div className={`w-2 h-2 rounded-full ${activeColor?.bg}`} />
            </div>
          </div>

          {/* Right: Icon Navigation with Expanding Pills */}
          <nav className="flex items-center gap-3">
            {navItems.map((item) => {
              const Icon = item.icon;
              const isActive = activeMainTab === item.id;
              const isHovered = hoveredIcon === item.id;
              const shouldExpand = isHovered;
              const itemColor = colorMap[item.color];

              return (
                <div key={item.id} className="relative">
                  <button
                    onMouseEnter={() => setHoveredIcon(item.id)}
                    onMouseLeave={() => setHoveredIcon(null)}
                    onClick={() => setActiveMainTab(item.id)}
                    className={`relative overflow-hidden transition-all duration-300 ease-out shadow-sm ${
                      isActive 
                        ? `${itemColor.bg} border-2 border-slate-900` 
                        : 'bg-white border border-stone-300 hover:border-slate-500'
                    }`}
                    style={{
                      width: shouldExpand ? '132px' : '48px',
                      height: '48px',
                      borderRadius: '24px',
                    }}
                  >
                    <div className="flex items-center h-full px-3 gap-2">
                      <Icon className={`w-6 h-6 flex-shrink-0 transition-colors justify-center duration-300 ${isActive ? 'text-white' : 'text-slate-600'}`} />
                      <span 
                        className={`text-sm font-medium whitespace-nowrap transition-all duration-300 ${
                          isActive ? 'text-white' : 'text-slate-900'
                        }`}
                        style={{
                          opacity: shouldExpand ? 1 : 0,
                          transform: shouldExpand ? 'translateX(0)' : 'translateX(-8px)',
                        }}
                      >
                        {item.label}
                      </span>
                    </div>
                  </button>
                  
                </div>
              );
            })}
          </nav>
        </div>

        {/* Enhanced Sub-navigation Bar */}
        <div className="border-2 border-slate-900 rounded-xl bg-white p-2.5 shadow-sm">
          <div className="flex items-center gap-2">
            {getCurrentSubTabs().map((tab, idx) => {
              const isActive = activeSubTab === tab.id;
              const currentTabs = getCurrentSubTabs();
              return (
                <React.Fragment key={tab.id}>
                  <button
                    onClick={() => setActiveSubTab(tab.id)}
                    className={`flex-1 px-4 py-3 rounded-lg text-sm transition-all ${
                      isActive 
                        ? 'bg-slate-900 text-white font-medium shadow-sm' 
                        : 'text-slate-700 hover:bg-stone-100'
                    }`}
                  >
                    {tab.label}
                  </button>
                  {!isActive && idx < currentTabs.length - 1 && (
                    <div className="w-px h-6 " />
                  )}
                </React.Fragment>
              );
            })}
          </div>
        </div>
      </div>
    );
  };
  const WrapperDesign2 = ({ isMobile = false }) => {
    const activeItem = navItems.find(item => item.id === activeMainTab);
    const activeColor = colorMap[activeItem?.color];

    if (isMobile) {
      return (
        <div className="bg-stone-50 px-4 py-4">
          {/* Mobile Header with Active Indicator */}
          <div className="flex items-center justify-between mb-4">
            <div className="flex items-center gap-2">
              <div className={`w-1 h-10 rounded-full ${activeColor?.bg}`} />
              <div>
                <div className="text-xs text-slate-600">College Journey</div>
                <div className="text-sm font-bold text-slate-900">{activeItem?.label}</div>
              </div>
            </div>
            <button 
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className={`w-10 h-10 rounded-full border-2 border-slate-900 flex items-center justify-center transition-all ${
                mobileMenuOpen ? 'bg-slate-900' : 'bg-white'
              }`}
            >
              <Menu className={`w-5 h-5 ${mobileMenuOpen ? 'text-white' : 'text-slate-900'}`} />
            </button>
          </div>

          {/* Mobile Navigation Grid */}
          {mobileMenuOpen && (
            <div className="mb-4 border-2 border-slate-900 rounded-xl bg-white p-3">
              <div className="grid grid-cols-4 gap-2">
                {navItems.map((item) => {
                  const Icon = item.icon;
                  const isActive = activeMainTab === item.id;
                  const itemColor = colorMap[item.color];
                  
                  return (
                    <button
                      key={item.id}
                      onClick={() => {
                        setActiveMainTab(item.id);
                        setMobileMenuOpen(false);
                      }}
                      className="relative flex flex-col items-center gap-2 p-3 rounded-xl transition-all"
                    >
                      <div className={`w-12 h-12 rounded-full flex items-center justify-center transition-all ${
                        isActive 
                          ? `${itemColor.bg} border-2 border-slate-900` 
                          : 'bg-stone-100'
                      }`}>
                        <Icon className={`w-5 h-5 ${isActive ? 'text-white' : 'text-slate-600'}`} />
                      </div>
                      <span className={`text-xs text-center ${isActive ? 'text-slate-900 font-medium' : 'text-slate-600'}`}>
                        {item.label}
                      </span>
                      {isActive && (
                        <div className={`absolute top-0 right-0 w-2 h-2 rounded-full ${itemColor.bg}`} />
                      )}
                    </button>
                  );
                })}
              </div>
            </div>
          )}

          {/* Mobile Sub-navigation - Improved */}
          <div className="border-2 border-slate-900 rounded-xl bg-white p-2">
            <div className="overflow-x-auto -mx-2 px-2">
              <div className="flex items-center gap-1.5 min-w-max">
                {getCurrentSubTabs().map((tab) => {
                  const isActive = activeSubTab === tab.id;
                  return (
                    <button
                      key={tab.id}
                      onClick={() => setActiveSubTab(tab.id)}
                      className={`px-4 py-2.5 rounded-lg text-sm whitespace-nowrap transition-all ${
                        isActive 
                          ? 'bg-slate-900 text-white font-medium' 
                          : 'text-slate-700 hover:bg-stone-100'
                      }`}
                    >
                      {tab.label}
                    </button>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className="bg-stone-50 px-8 py-6">
        {/* Top Bar */}
        <div className="flex items-center justify-between mb-6">
          {/* Left: Enhanced Breadcrumb with Color Accent */}
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full bg-white border-2 border-slate-900 flex items-center justify-center">
              <Home className="w-5 h-5 text-slate-900" />
            </div>
            <ChevronRight className="w-4 h-4 text-stone-400" />
            <span className="text-sm text-slate-600">College Journey</span>
            <ChevronRight className="w-4 h-4 text-stone-400" />
            <div className={`px-2 py-2 flex items-center gap-2 `}>
              <span className="text-sm text-slate-900 font-medium">{activeItem?.label}</span>
              <div className={`w-2 h-2 rounded-full ${activeColor?.bg}`} />
            </div>
          </div>

          {/* Right: Icon Navigation with Expanding Pills */}
          <nav className="flex items-center gap-3">
            {navItems.map((item) => {
              const Icon = item.icon;
              const isActive = activeMainTab === item.id;
              const isHovered = hoveredIcon === item.id;
              const shouldExpand = isHovered;
              const itemColor = colorMap[item.color];

              return (
                <div key={item.id} className="relative">
                  <button
                    onMouseEnter={() => setHoveredIcon(item.id)}
                    onMouseLeave={() => setHoveredIcon(null)}
                    onClick={() => setActiveMainTab(item.id)}
                    className={`relative overflow-hidden transition-all duration-300 ease-out shadow-sm ${
                      isActive 
                        ? `${itemColor.bg} border-2 border-slate-900` 
                        : 'bg-white border border-stone-300 hover:border-slate-500'
                    }`}
                    style={{
                      width: shouldExpand ? '132px' : '48px',
                      height: '48px',
                      borderRadius: '24px',
                    }}
                  >
                    <div className="flex items-center h-full px-3 gap-2">
                      <Icon className={`w-6 h-6 flex-shrink-0 transition-colors justify-center duration-300 ${isActive ? 'text-white' : 'text-slate-600'}`} />
                      <span 
                        className={`text-sm font-medium whitespace-nowrap transition-all duration-300 ${
                          isActive ? 'text-white' : 'text-slate-900'
                        }`}
                        style={{
                          opacity: shouldExpand ? 1 : 0,
                          transform: shouldExpand ? 'translateX(0)' : 'translateX(-8px)',
                        }}
                      >
                        {item.label}
                      </span>
                    </div>
                  </button>
                  
                </div>
              );
            })}
          </nav>
        </div>

        {/* Enhanced Sub-navigation Bar */}
        <div className="border-2 border-slate-900 rounded-xl bg-white p-2.5 shadow-sm">
          <div className="flex items-center gap-2">
            {getCurrentSubTabs().map((tab, idx) => {
              const isActive = activeSubTab === tab.id;
              const currentTabs = getCurrentSubTabs();
              return (
                <React.Fragment key={tab.id}>
                  <button
                    onClick={() => setActiveSubTab(tab.id)}
                    className={`flex-1 px-4 py-3 rounded-lg text-sm transition-all ${
                      isActive 
                        ? 'bg-slate-900 text-white font-medium shadow-sm' 
                        : 'text-slate-700 hover:bg-stone-100'
                    }`}
                  >
                    {tab.label}
                  </button>
                  {!isActive && idx < currentTabs.length - 1 && (
                    <div className="w-px h-6 " />
                  )}
                </React.Fragment>
              );
            })}
          </div>
        </div>

        
        {/* Navigation Header */}
        <div className="bg-slate-800 border-2 border-slate-900 rounded-xl mb-6 p-4 mt-6 z-100 overflow-visible">
          <div className="flex items-center justify-between">
            
            {/* Left: Back to Grid */}
            <button 
              onClick={() => alert('Navigate back to grid view')}
              className="flex items-center gap-2 text-stone-50 hover:text-white transition-colors"
            >
              <Grid3x3 className="w-4 h-4" />
              <span className="text-sm font-medium">My Colleges</span>
            </button>

            {/* Center: College Browser */}
            <div className="flex items-center gap-4">
              
              {/* Previous Button */}
              <button
                onClick={handlePrevious}
                disabled={currentCollege === 1}
                className={`p-2 rounded-lg border-2 transition-all ${
                  currentCollege === 1 
                    ? 'border-stone-300 text-stone-400 cursor-not-allowed' 
                    : 'border-slate-900 text-stone-50 hover:bg-stone-teal-400 active:scale-95'
                }`}
              >
                <ChevronLeft className="w-5 h-5" />
              </button>

              {/* Current College Indicator with Quick Nav */}
              <div className="relative">
                <button
                  onClick={() => setShowQuickNav(!showQuickNav)}
                  className="px-6 py-2 bg-stone-50 border border-slate-900 rounded-lg hover:bg-stone-100 transition-colors"
                >
                  <div className="flex items-center gap-3">
                    <span className={`text-xs font-bold uppercase tracking-wide ${getCategoryTextColor(college.category)}`}>
                      {college.category}
                    </span>
                    <span className="text-sm text-slate-900 font-medium">
                      {currentCollege} of {allColleges.length}
                    </span>
                  </div>
                </button>

                {/* Quick Navigation Dropdown */}
                {showQuickNav && (
                  <div className="overflow-y-auto absolute top-full mt-2 left-0 right-0 bg-white border-2 border-slate-900 rounded-lg shadow-lg z-100 min-w-[300px] max-h-[300px] overflow-visible">
                    
                    {/* Reach Schools */}
                    <div className="border-b border-stone-200">
                      <div className="px-4 py-2 bg-coral-50 border-b border-coral-200">
                        <span className="text-xs font-bold uppercase tracking-wide text-coral-700">Reach Schools</span>
                      </div>
                      {colleges.reach.map((c) => (
                        <button
                          key={c.id}
                          onClick={() => {
                            setCurrentCollege(c.id);
                            setShowQuickNav(false);
                          }}
                          className={`w-full text-left px-4 py-2 text-sm hover:bg-stone-50 transition-colors ${
                            c.id === currentCollege ? 'bg-stone-100 font-medium' : ''
                          }`}
                        >
                          {c.name}
                        </button>
                      ))}
                    </div>

                    {/* Target Schools */}
                    <div className="border-b border-stone-200">
                      <div className="px-4 py-2 bg-gold-50 border-b border-gold-200">
                        <span className="text-xs font-bold uppercase tracking-wide text-gold-700">Target Schools</span>
                      </div>
                      {colleges.target.map((c) => (
                        <button
                          key={c.id}
                          onClick={() => {
                            setCurrentCollege(c.id);
                            setShowQuickNav(false);
                          }}
                          className={`w-full text-left px-4 py-2 text-sm hover:bg-stone-50 transition-colors ${
                            c.id === currentCollege ? 'bg-stone-100 font-medium' : ''
                          }`}
                        >
                          {c.name}
                        </button>
                      ))}
                    </div>

                    {/* Safety Schools */}
                    <div>
                      <div className="px-4 py-2 bg-teal-50 border-b border-teal-200">
                        <span className="text-xs font-bold uppercase tracking-wide text-teal-700">Safety Schools</span>
                      </div>
                      {colleges.safety.map((c) => (
                        <button
                          key={c.id}
                          onClick={() => {
                            setCurrentCollege(c.id);
                            setShowQuickNav(false);
                          }}
                          className={`w-full text-left px-4 py-2 text-sm hover:bg-stone-50 transition-colors ${
                            c.id === currentCollege ? 'bg-stone-100 font-medium' : ''
                          }`}
                        >
                          {c.name}
                        </button>
                      ))}
                    </div>
                  </div>
                )}
              </div>

              {/* Next Button */}
              <button
                onClick={handleNext}
                disabled={currentCollege === allColleges.length}
                className={`p-2 rounded-lg border-2 transition-all ${
                  currentCollege === allColleges.length
                    ? 'border-stone-300 text-stone-400 cursor-not-allowed'
                    : 'border-slate-900 text-stone-50 hover:bg-stone-teal-400 active:scale-95'
                }`}
              >
                <ChevronRight className="w-5 h-5" />
              </button>
            </div>

            {/* Right: Keyboard Hint */}
            <div className="flex items-center gap-2 text-xs text-stone-100">
              <kbd className="px-2 py-1 bg-stone-100 border text-slate-900 border-stone-100 rounded">←</kbd>
              <kbd className="px-2 py-1 bg-stone-100 border text-slate-900 border-stone-100 rounded">→</kbd>
              <span>to navigate</span>
            </div>
          </div>
        </div>

        </div>
      );
    };

  const variations = [
    { 
      id: 1, 
      name: 'Essay', 
      mainTab: 'essays',
      subTab: 'ideation',
      desktop: <WrapperDesign1 />,
      mobile: <WrapperDesign1 isMobile={true} />
    },
    
{ 
      id: 2, 
      name: 'Profile', 
      mainTab: 'profile',
      subTab: 'academic',
      desktop: <WrapperDesign1 />,
      mobile: <WrapperDesign1 isMobile={true} />
    },
{ 
      id: 3, 
      name: 'Colleges', 
      mainTab: 'colleges',
      subTab: 'my-schools',
      desktop: <WrapperDesign1 />,
      mobile: <WrapperDesign1 isMobile={true} />
    },
    {
        id: 4,
        name: 'Recommendations',
        mainTab: 'recommendations',
        subTab: 'all-recommendations',
        desktop: <WrapperDesign1 />,
        mobile: <WrapperDesign1 isMobile={true} />
    },
    {
        id: 5,
        name: 'Aid',
        mainTab: 'aid',
        subTab: 'financial-aid',
        desktop: <WrapperDesign1 />,
        mobile: <WrapperDesign1 isMobile={true} />
    },
    {
        id: 6,
        name: 'Timeline',
        mainTab: 'timeline',
        subTab: 'timeline',
        desktop: <WrapperDesign1 />,
        mobile: <WrapperDesign1 isMobile={true} />
    },

    { id: 7,
        name: 'Colleges',
        mainTab: 'college',
        subTab: 'colleges',
        desktop: <WrapperDesign2 />,
        mobile: <WrapperDesign1 isMobile={true} />
    }
  ];

 


  return (
    <div className="min-h-screen bg-stone-100 p-8">
      <div className="max-w-7xl mx-auto space-y-8">
        {/* Selector */}
        <div className="bg-white border-2 border-slate-900 rounded-xl p-6">
          <h2 className="text-lg font-bold text-slate-900 mb-4">Select Version</h2>
          <div className="flex gap-3">
            {variations.map((variation) => (
              <button
                key={variation.id}
                onClick={() => {
                  setSelectedVariation(variation.id);
                  setActiveMainTab(variation.mainTab);
                  setActiveSubTab(variation.subTab);
                }}
                className={`px-6 py-3 rounded-lg border-2 transition-all text-sm font-medium ${
                  selectedVariation === variation.id
                    ? 'border-slate-900 bg-slate-900 text-white'
                    : 'border-stone-300 bg-white text-slate-700 hover:border-slate-500'
                }`}
              >
                {variation.name}
              </button>
            ))}
          </div>
        </div>

        {/* Desktop Version */}
        <div className="space-y-3 overflow-visible">
          <div className="flex items-center gap-3">
            <h3 className="text-sm font-bold text-slate-900">Desktop Version</h3>
            <div className="h-px flex-1 bg-stone-300" />
          </div>
          <div className="bg-white border-2 border-slate-900 rounded-xl overflow-visible z-100">
            {variations[selectedVariation - 1].desktop}
          </div>
        </div>

        {/* Mobile Version */}
        <div className="space-y-3">
          <div className="flex items-center gap-3">
            <h3 className="text-sm font-bold text-slate-900">Mobile Version</h3>
            <div className="h-px flex-1 bg-stone-300" />
          </div>
          <div className="bg-white border-2 border-slate-900 rounded-xl overflow-hidden max-w-md">
            {variations[selectedVariation - 1].mobile}
          </div>
        </div>

        {/* Design Notes */}
        <div className="bg-white border border-slate-900 rounded-xl p-6">
          <h3 className="text-sm font-bold text-slate-900 mb-4 flex items-center gap-2">
            Design Notes
            <div className="w-1.5 h-1.5 rounded-full bg-teal-500" />
          </h3>
          
          <div className="space-y-4 text-sm text-slate-700">
            <div>
              <div className="font-medium text-slate-900 mb-2">Smooth Animation Details:</div>
              <div className="text-xs leading-relaxed space-y-1">
                <div>• <strong>Fixed width transition:</strong> Button width animates with fixed expanded size (140px/132px)</div>
                <div>• <strong>Transform-based reveal:</strong> Label uses translateX(-8px) to 0 for smooth slide-in</div>
                <div>• <strong>Opacity fade:</strong> Text opacity transitions 0 → 1 simultaneously</div>
                <div>• <strong>Duration:</strong> 300ms with ease-out timing for natural deceleration</div>
                <div>• <strong>GPU acceleration:</strong> Using transform and opacity for 60fps animation</div>
              </div>
            </div>

            
          </div>
        </div>
      </div>
    </div>
  );
};

export default CJWrapperNav;